import { j as t } from "./jsx-runtime-944c88e2.js";
import { InfoOutlineIcon as $ } from "@chakra-ui/icons";
import { useToast as M, Highlight as N, Editable as O, Tooltip as C, EditablePreview as R, useColorModeValue as U, Input as W, EditableInput as q } from "@chakra-ui/react";
import { useState as d, useEffect as E } from "react";
import { b as j, a as z, ah as B, ai as G, f as J } from "./eMyAsurionProvider-b8eadbb8.js";
import { T as Et, T as jt, j as vt } from "./eMyAsurionProvider-b8eadbb8.js";
import "@tanstack/react-query";
import "react-router-dom";
import "./useAccount-b28f5367.js";
import "./lodash-9598aa3c.js";
import "./myasurion-shared.mixpanel.es.js";
import "mixpanel-browser";
import "./domains-7d097fe4.js";
import "./features-624d7c1d.js";
import "./myasurion-shared.carrier.es.js";
import "./cleave-react-node-c4a374e5.js";
import "@emotion/react";
import "@emotion/styled";
import "./providers-e4ae81b1.js";
import "framer-motion";
import "@react-oauth/google";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
const v = ({
  text: c = "",
  translationKey: i,
  // languageCode,
  // usage = 'static',
  module: u,
  section: l,
  values: I
}) => {
  const k = (e, s) => e.replace(/\{(\d+)\}/g, (a, n) => s[n - 1]), [o, m] = d(c), [r, f] = d(
    k(c, I || [])
  ), [x, S] = d(!1), [g, F] = d(!1), T = M(), { translationAPI: b } = j(), { registerComponent: P, unregisterComponent: D } = z(), {
    entries: p,
    getTextEntry: V,
    localeLanguage: h,
    updateEntry: A,
    setLocalModule: H,
    isTranslationsActive: w
  } = j(), y = async () => {
    var e;
    S(!0);
    try {
      if (p) {
        if (!b.api)
          throw "No api found for translation";
        const s = await J(b.api, h, u);
        if (s === null)
          throw "No fetched strings data found";
        const a = (e = s.body.find((n) => n.id === l)) == null ? void 0 : e.text.find((n) => n.path === i);
        a && await A(a == null ? void 0 : a.internalId, l, o), f(o);
      }
      T({
        title: "Text saved successfully!",
        description: `${o} is successfully saved to locale ${h}`,
        status: "success",
        duration: 1500,
        isClosable: !0
      });
    } catch {
      T({
        title: "Error in saving entry",
        description: "Something went wrong",
        status: "error",
        duration: 2e3,
        isClosable: !0
      });
    }
  }, L = (e) => {
    e.key == "Enter" && y();
  }, _ = () => {
    m(c);
  };
  return E(() => {
    m(r);
    const { textEntry: e } = V(i, l);
    f(e || r), H(u);
  }, [r, p, w]), E(() => (P(
    v,
    o,
    {
      module: u,
      section: l,
      path: i
    },
    p
  ), () => {
    D(v, i);
  }), [r, h, p]), w === !1 ? x ? /* @__PURE__ */ t.jsx(
    N,
    {
      query: r,
      styles: { px: "1", py: "1", bg: "orange.100" },
      children: r
    }
  ) : /* @__PURE__ */ t.jsx(t.Fragment, { children: r }) : /* @__PURE__ */ t.jsxs(
    O,
    {
      defaultValue: r,
      isPreviewFocusable: !0,
      selectAllOnFocus: !1,
      onChange: (e) => m(e),
      value: o,
      children: [
        g ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          "Translation Path ID: ",
          i
        ] }) : /* @__PURE__ */ t.jsx(C, { label: "Click to edit", shouldWrapChildren: !0, children: /* @__PURE__ */ t.jsx(
          R,
          {
            as: x ? "mark" : "span",
            px: 1,
            py: 1,
            position: "relative",
            paddingRight: "25px",
            border: "1px solid #ccc",
            background: x ? "#FEEBC8" : "",
            cursor: "text",
            _hover: {
              background: U("gray.200", "gray.700"),
              color: "black"
            },
            minHeight: "32px",
            _after: {
              content: '""',
              position: "absolute",
              top: "5px",
              right: "5px",
              width: "13px",
              height: "13px",
              backgroundImage: `url("${B}")`,
              backgroundSize: "cover"
            }
          }
        ) }),
        /* @__PURE__ */ t.jsx(C, { label: "Toggle between path id and translation", shouldWrapChildren: !0, children: /* @__PURE__ */ t.jsx(
          $,
          {
            as: "button",
            mx: 1,
            cursor: "pointer",
            w: "14px",
            h: "14px",
            onClick: () => {
              console.log(g), F(!g);
            }
          }
        ) }),
        /* @__PURE__ */ t.jsx(W, { py: 2, px: 4, as: q, value: o, onKeyDown: L }),
        /* @__PURE__ */ t.jsx(G, { handleSave: y, handleCancel: _ })
      ]
    }
  );
};
export {
  Et as TextScript,
  jt as TextString,
  v as TextTranslation,
  vt as getTextScript
};
